import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export const Portal = ({
  children,
  togglePortal,
}: {
  children: React.ReactNode;
  togglePortal?: () => void;
}) => {
  let portal: any = null;
  useEffect(() => {
    const closePortal = (evt: Event) => {
      const { target } = evt;
      if (togglePortal && portal && !portal.contains(target)) togglePortal();
    };
    document.addEventListener('click', closePortal, false);
    return () => document.removeEventListener('click', closePortal, false);
  }, [togglePortal, portal]);

  return ReactDOM.createPortal(
    <div
      ref={(node) => {
        portal = node;
      }}
      className="portal"
    >
      {children}
    </div>,
    document.body
  );
};
